// lib/components/popup-portal/popup-portal/popup-portal.tsx
import ReactDOM from "react-dom";
import { jsx } from "@emotion/react/jsx-runtime";
var AscendPopupContainerId = "ascend-popup-container-id";
var PopupContainer = () => /* @__PURE__ */ jsx("div", { id: AscendPopupContainerId });
var PopupPortal = ({ children }) => {
  return ReactDOM.createPortal(
    children,
    document.getElementById(AscendPopupContainerId)
  );
};

export {
  AscendPopupContainerId,
  PopupContainer,
  PopupPortal
};
